<div class="start-page__wrapper">
  <div class="start-page__container">
    <app-tile
      variant="together"
      [title]="'startPage.together'"
      [iconName]="'arrow_forward_ios'"
      [link]="'/together'"
    ></app-tile>
    @if (userService.hasRole("User")) {
      <app-tile imageName="tile/my-profile_blue.png" [title]="'startPage.myProfile'" [iconName]="'arrow_forward_ios'"
                [link]="'/profile/me'"></app-tile>
    }
    @if (userService.hasRole("Office") || userService.hasRole("Admin") || userService.hasRole('Sale')) {
      <app-tile imageName="tile/consultant-overview_blue.png" [title]="'startPage.consultantOverview'"
                [iconName]="'arrow_forward_ios'" [link]="'/berater-list'"></app-tile>
      <app-tile imageName="tile/bench_blue.png" [title]="'startPage.benchOverview'" [iconName]="'arrow_forward_ios'"
                [link]="'/berater-abfrage'"></app-tile>
    }
    @if (userService.hasRole("Office") || userService.hasRole("Admin")) {
      <app-tile imageName="tile/certificates_blue.png" [title]="'startPage.testimonyTexts'" [iconName]="'arrow_forward_ios'"
                [link]="'/report'"></app-tile>
    }
    @if (userService.hasRole("Sale") || userService.hasRole("Admin") || userService.hasRole("Office")) {
      <app-tile imageName="tile/catalog_blue.png" [title]="'startPage.manageCatalog'" [iconName]="'arrow_forward_ios'"
                [link]="'/katalog'"></app-tile>
    }
    @if (userService.hasRole("Admin") || userService.hasRole("Office")) {
      <app-tile imageName="tile/skills_blue.png" [title]="'startPage.manageSkills'" [iconName]="'arrow_forward_ios'"
                [link]="'/skills'"></app-tile>
      <app-tile imageName="tile/admin-dashboard_blue.png" [title]="'startPage.adminDashboard'" [iconName]="'arrow_forward_ios'"
                [link]="'/administration'"></app-tile>
      <app-tile imageName='tile/requests_blue.png' [title]="'startPage.requests'" [iconName]="'arrow_forward_ios'"
                [link]="'/requests'"></app-tile>
    }
    @if (userService.hasRole("Admin")) {
      <app-tile imageName='tile/maintenance_blue.png' [title]="'startPage.maintenance'" [iconName]="'arrow_forward_ios'"
                [link]="'/admin/wartung'"></app-tile>
    }
  </div>
</div>
